<div class="d-flex jce">
  <button color="primary" mat-flat-button (click)="openProtocolDialog()">Sendungsprotokoll</button>
</div>

<form [formGroup]="configForm" (ngSubmit)="submitConfigForm()" class="mt-l datconfigform">
  <div class="d-flex jce">
    <p class="w-30 text-center">E-Mail Benachrichtigung bei Übertragungsfehlern</p>
  </div>
  <div class="d-flex jcsb">
      <mat-form-field appearance="outline"  class="w-30">
        <mat-label>Beraternummer/Mandantennummer</mat-label>
        <input matInput formControlName="client_id" tabindex="1" readonly>
      </mat-form-field>


    <mat-form-field appearance="outline" class="w-30">
      <mat-label>Bemerkung</mat-label>
      <input matInput formControlName="note" tabindex="5">
    </mat-form-field>
    <mat-slide-toggle formControlName="notify" color="primary" class="w-30 text-center"></mat-slide-toggle>
  </div>
    @if(userService.mainIdf() !== userService.selectedIdf()) {
     <a (click)="createNewToken()" class="red cursor-pointer">Ich habe mehrere Mandantennummern</a>
    }

  <p class="my-l">Sie können jeder Hageda Belegart einen DATEV Belegtyp zuordnen. Neue Rechnungen werden somit
    automatisch im richtigen Verzeichnis abgelegt. Erfolgt keine individuelle Zuordnung werden die Rechnungen
    standardmäßig „Ohne Belegtyp“ an DATEV übertragen.</p>

  <div class="d-flex jce">
    <p class="w-30 text-center">Belegart an DATEV übertragen</p>
  </div>
  @if (docTypes.length) {
    @for (docType of docTypes; track docType) {
      <div class="d-flex jcsb">
        <p class="w-30 text-center">{{ docType.value }}</p>
        <div class="w-30" formGroupName="documents">
          <mat-form-field appearance="outline" class="datselect">
            <mat-label>DATEV Belegtyp</mat-label>
            <mat-select [formControlName]="docType.attribute">
              <mat-option value="" disabled>Auswahl der DATEV Belegtyp</mat-option>
              @for (datevDoc of datevDocuments; track datevDoc) {
                <mat-option [value]="datevDoc">
                  {{ datevDoc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div formGroupName="send" class="w-30 text-center">
          <mat-slide-toggle [formControlName]="docType.attribute + '-send'" color="primary"></mat-slide-toggle>
        </div>
      </div>
    }
  } @else {
    <p>Laden...</p>
  }

  <div class="d-flex jce align-items-center">
    <button mat-button
            color="tertiary"
            type="button"
            (click)="onDeactivate()"
            [disabled]="!configForm.valid">
      Deaktivieren
    </button>
    <button mat-flat-button
            class="ml-s"
            color="primary"
            type="submit"
            [disabled]="!configForm.valid">
      Konfiguration speichern
    </button>
  </div>
</form>
